// Tipovi i konstante
import { InvoiceSearchPageCmp, InvoiceSearchPageProps } from "./types";

// UI komponente
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { Tabs } from "ui/components/Tabs";

// Moduli specifični za projekt
import { Routes } from "ui/modules/finance/navigation";

// Lokalne komponente
import InvoiceSaleSearchTab from "./components/InvoiceSaleSearchTab/InvoiceSaleSearchTab";
import InvoiceRentSearchTab from "./components/InvoiceRentSearchTab/InvoiceRentSearchTab";
import InvoiceIncomingSearchTab from "./components/InvoiceIncomingSearchTab/InvoiceIncomingSearchTab";
import { INVOICE_SEARCH_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { useTranslate } from "helpers";
import { Breadcrumb } from "ui/components/Breadcrumb";

const InvoiceSearchPage: InvoiceSearchPageCmp = (
  props: InvoiceSearchPageProps
) => {

  const { t } = useTranslate();

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md border border-b mb-2">
          <PageHeader>
            <div className="flex gap-3">
              <div>
                <PageTitle
                  title={`${t(INVOICE_SEARCH_PAGE_TITLE.text)}`}
                  icon={INVOICE_SEARCH_PAGE_TITLE.icon}
                  iconColor={INVOICE_SEARCH_PAGE_TITLE.iconColor}
                />
                <Breadcrumb />
              </div>
            </div>
          </PageHeader>
        </div>
        <Tabs
          tabs={[
            {
              label: "Izlazni računi",
              queryParam: "outgoing",
              content: (
                <div className="px-0 pt-6 pb-8 mt-[-1px] xl:px-6">
                  <Tabs
                    variant="pill"
                    queryParamName="subtab"
                    tabs={[
                      {
                        label: "Prodaja vozila",
                        queryParam: "sale",
                        content: (
                          <div>
                            <InvoiceSaleSearchTab />
                          </div>
                        ),
                      },
                      {
                        label: "Najam vozila",
                        queryParam: "rent",
                        content: (
                          <div>
                            <InvoiceRentSearchTab />
                          </div>
                        ),
                      },
                    ]}
                  />
                </div>
              ),
            },
            {
              label: "Ulazni računi",
              queryParam: "incoming",
              content: (
                <div>
                  <InvoiceIncomingSearchTab />
                </div>
              ),
            },
          ]}
        />
      </div>

    </>
  );
};

InvoiceSearchPage.route = Routes.InvoiceSearchPageRouter;

export default InvoiceSearchPage;
